<main class="main-float">
    <router-outlet class="main-float"></router-outlet>
</main>